module.exports = __webpack_public_path__ + "img/01.c36b8e76.png";